import { css } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"

import RadioAndCheckBoxBase from "../RadioAndCheckBoxBase"

import off from "./off.png"
import on from "./on.png"

type Props = Omit<React.ComponentProps<typeof RadioAndCheckBoxBase>, "type" | "renderIcon">

const CheckBox = (props: Props) => {
  const { checked } = props

  return (
    <RadioAndCheckBoxBase
      type="checkbox"
      renderIcon={(isFocusVisible) => (
        <span className={isFocusVisible ? styles.focus : undefined}>
          <Image src={checked ? on : off} alt="" width={13} height={13} />
        </span>
      )}
      {...props}
    />
  )
}
export default CheckBox

const styles = {
  focus: css`
    outline: 1px auto black;
    outline-offset: 2px;
  `,
}
